<template>
  <main :class="pageData ? '' : 'loading'">
    <div class="content container">
      <div class="gallery full" v-if="currentGallery">
        <header>
          <h1>{{ currentGallery.gallery_name }}</h1>
          <button v-if="galleries.length > 1" class="btn btn-lg btn-primary" @click="goBack">Back to Gallery</button>
        </header>
        <gallery-full :gallery="currentGallery"></gallery-full>
        <p class="text-center" :style="{ marginBottom: '80px' }">
          <button v-if="galleries.length > 1" class="btn btn-lg btn-primary" @click="goBack">Back to Gallery</button>
        </p>
      </div>
      <div class="gallery" v-else-if="galleries && galleries.length > 1">
        <header>
          <h1>Gallery</h1>
        </header>
        <div class="gallery-thumb-grid">
          <div class="thumb" v-for="(gallery, i) in galleries" @click="setCurrentGallery(gallery)" :key="i">
            <gallery-thumb :gallery="gallery"></gallery-thumb>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import PageHeader from './layouts/PageHeader'
import GalleryThumb from './Gallery/GalleryThumb'
import GalleryFull from './Gallery/GalleryFull'

import slugify from 'slugify'

export default {
  data() {
    return {
      headerTitle: 'Gallery',
      headerImage: 'PFK_OurStory_Photo1_800x290.jpg',
      pageData: null,
      currentGallery: null
    }
  },
  mounted() {
    this.getPageData()
    this.checkHash()
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.goBack)
  },
  methods: {
    setCurrentGallery(gallery) {
      this.$router.push('/gallery#' + slugify(gallery.gallery_name, { lower: true }))
      window.addEventListener('popstate', this.goBack)
      this.currentGallery = gallery
    },
    goBack() {
      this.currentGallery = null
      window.removeEventListener('popstate', this.goBack)
      this.$router.push('/gallery')
    },
    getPageData() {
      const vm = this
      vm.$http.get('/pages?slug=gallery')
        .then((response) => {
          vm.pageData = response.data[0]
        })
    },
    checkHash() {
      if (this.$route.hash) this.$router.replace('/gallery')
    }
  },
  components: {
    PageHeader,
    GalleryThumb,
    GalleryFull
  },
  computed: {
    galleries() {
      if (this.pageData && this.pageData.acf) return this.pageData.acf.galleries
    }
  },
  watch: {
    galleries(val) {
      if (val.length === 1) {
        this.setCurrentGallery(val[0])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~assets/styles/vars";

.content {
  padding-top: 40px;
}

.gallery-thumb-grid {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 60px;

  .thumb {
    @include media('tablet') {
      width: 49%;
      margin-bottom: 2%;

      &:not(:nth-child(2n)) {
        margin-right: 2%;
      }
    }

    @include media('tablet-wide') {
      width: 32%;

      &:not(:nth-child(2n)) {
        margin-right: 0;
      }

      &:not(:nth-child(3n)) {
        margin-right: 2%;
      }
    }
  }
}

.thumb {
  cursor: pointer;
}

.gallery {
  header {
    margin-top: 20px;
    margin-bottom: 50px;

    h1 {
      margin: 0;
    }

    @include media('tablet-wide') {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Gallery.vue?06f717c6